import { useEffect, useState, ReactElement } from "react";

import FlexColumn from "../../layout/Flexbox/FlexColumn";
import FlexRow from "../../layout/Flexbox/FlexRow";

import "./NumericSpinner_style.css";

type Props = Readonly<{
    id?: string,
    label?: string | null,
    value?: number,
    onChange?: (val: number) => void,
    style?: React.CSSProperties,
    onEnterKeyPress?: () => void,
    placeholderText?: string | null,
    min?: number,
    max?: number,
}>;

export default function NumericSpinner({id = undefined, label = null, value, onChange, style, onEnterKeyPress, placeholderText, min = 0, max = 100}: Props): ReactElement {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            onEnterKeyPress?.();
        }
    };

    return (
        <div id={id} className="text-input-component" style={style}>
            <FlexColumn gap={8}>
                {label != null && (<p className="input-label">{label}</p>)}
                <div className="text-input">
                    <input 
                        className="numeric-spinner"
                        name="numeric-spinner"
                        type="number"
                        value={value}
                        onKeyDown={(event) => {
                            handleKeyDown(event);
                        }}
                        onChange={(event) => {
                            const newValueRaw = event.target.value;
                            const newValueParsed = Number.parseInt(newValueRaw);

                            onChange?.(newValueParsed);
                        }}
                        min={min}
                        max={max}
                    />
                    {placeholderText == null || value != null ? 
                        null : 
                        <p className="placeholder-text">
                            {placeholderText}
                        </p>
                    }
                </div>
            </FlexColumn>
        </div>
    );
}
